import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Chip,
} from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./AccommodationCard.css";
import BookModal from "./BookModal";
import { filterProperties } from "@turf/turf";
import { useTranslation } from "react-i18next";

const AccommodationCard = ({
  accommodation,
  indexAmongSameResidences = 0,
  filters,
}) => {
  const { t } = useTranslation();

  const {
    propertyName,
    roomTypeName,
    propertyImage,
    roomImages,
    dailyPrice,
    normalDailyPrice,
    propertyNearByUniversities,
    totalPrice,
    duration,
    checkin,
    checkout,
  } = accommodation;

  const [bookModalOpen, setBookModalOpen] = useState();

  const paraFormat = (number) => {
    const formatter = new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
    });
    return formatter.format(number);
  };

  // Format dates for display
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "/");
  };

  // Calculate discount percentage
  const discountPercentage = Math.round(
    ((normalDailyPrice - dailyPrice) / normalDailyPrice) * 100
  );

  // Use room images if available, otherwise use property images

  const rawImages =
    roomImages && roomImages.length > 0
      ? roomImages
      : propertyImage && propertyImage.length > 0
        ? propertyImage
        : [];

  const imagesToShow =
    rawImages.length > 1
      ? [
        ...rawImages.slice(indexAmongSameResidences),
        ...rawImages.slice(0, indexAmongSameResidences),
      ]
      : rawImages;

  // const imagesToShow =
  //   roomImages && roomImages.length > 0
  //     ? roomImages
  //     : propertyImage && propertyImage.length > 0
  //     ? propertyImage
  //     : [];

  return (
    <>
      <Card className="accommodation-card">
        <Box className="image-container">
          <Box className="price-tag">
            <Typography color={"#fff"} variant="h6" component="div">
              {paraFormat(dailyPrice)}
            </Typography>
            <Typography variant="caption" component="div">
              /{t("night")}
            </Typography>
          </Box>

          <Swiper
            modules={[Navigation, Pagination]}
            navigation
            pagination={{ clickable: true }}
            className="swiper-container"
          >
            {imagesToShow.slice(0, 15).map((image, index) => (
              <SwiperSlide key={index}>
                <img
                  src={image || "/placeholder.svg"}
                  alt={`${propertyName} - ${index + 1}`}
                  className="property-image"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>

        <CardContent
          sx={{
            height: "calc(100% - 300px)",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Typography variant="h5" component="div" gutterBottom>
            {propertyName}
          </Typography>

          <Chip
            label={`${duration} ${t("night")}`}
            color="primary"
            variant="outlined"
            sx={{ mb: 2 }}
          />

          <Typography variant="h6" component="div" gutterBottom>
            {roomTypeName}
          </Typography>

          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" color="text.secondary">
              {t("checkIn")} : {formatDate(checkin)}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t("checkOut")} : {formatDate(checkout)}
            </Typography>
          </Box>

          {/* <Box sx={{ mb: 2 }}>
            {propertyNearByUniversities?.map((item, idx) => {
              return (
                <Box>
                  <Typography
                    sx={{
                      color:
                        filters?.university === item?.university_title
                          ? "red"
                          : "black",
                    }}
                    variant="caption"
                  >
                    {item?.university_title}
                  </Typography>
                </Box>
              );
            })}
          </Box> */}

          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <Typography
              variant="h5"
              component="div"
              color="primary"
              sx={{ fontWeight: "bold" }}
            >
              {paraFormat(totalPrice)}
            </Typography>
            <Typography variant="body2" sx={{ ml: 1 }}>
              /{t("total")}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ ml: 1, textDecoration: "line-through" }}
            >
              {paraFormat(normalDailyPrice * duration)}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", gap: 2, mt: "auto" }}>
            <Button
              onClick={() => setBookModalOpen(true)}
              variant="contained"
              color="secondary"
              sx={{ flex: 1, textTransform: 'capitalize' }}
            >
              {t("bookNow")} / {t("enquiry")}
            </Button>
          </Box>
        </CardContent>
      </Card>
      <BookModal
        accommodation={accommodation}
        open={bookModalOpen}
        onClose={() => setBookModalOpen(false)}
      />
    </>
  );
};

export default AccommodationCard;
